"use strict";
var appn;
(function (appn) {
    let UserStatus;
    (function (UserStatus) {
        UserStatus["Invited"] = "Invited";
        UserStatus["Active"] = "Active";
        UserStatus["Inactive"] = "Inactive";
    })(UserStatus = appn.UserStatus || (appn.UserStatus = {}));
    let UserType;
    (function (UserType) {
        UserType["Full"] = "Full";
        UserType["Premium"] = "Premium";
        UserType["Standard"] = "Standard";
        UserType["Edge"] = "Edge";
        UserType["Pro"] = "Pro";
    })(UserType = appn.UserType || (appn.UserType = {}));
    let DataSourceType;
    (function (DataSourceType) {
        DataSourceType["UserDefined"] = "UserDefined";
        DataSourceType["Connected"] = "Connected";
        DataSourceType["System"] = "System";
        DataSourceType["App"] = "App";
    })(DataSourceType = appn.DataSourceType || (appn.DataSourceType = {}));
    let TwoFactorAuthMode;
    (function (TwoFactorAuthMode) {
        TwoFactorAuthMode["Disabled"] = "Disabled";
        TwoFactorAuthMode["EnabledPortalOnly"] = "EnabledPortalOnly";
        TwoFactorAuthMode["EnabledPortalAndApp"] = "EnabledPortalAndApp";
    })(TwoFactorAuthMode = appn.TwoFactorAuthMode || (appn.TwoFactorAuthMode = {}));
    let TwoFactorAuthPreferredApp;
    (function (TwoFactorAuthPreferredApp) {
        TwoFactorAuthPreferredApp["None"] = "None";
        TwoFactorAuthPreferredApp["OnePassword"] = "OnePassword";
        TwoFactorAuthPreferredApp["Authy"] = "Authy";
        TwoFactorAuthPreferredApp["BitWarden"] = "BitWarden";
        TwoFactorAuthPreferredApp["Google"] = "Google";
        TwoFactorAuthPreferredApp["LastPass"] = "LastPass";
        TwoFactorAuthPreferredApp["Microsoft"] = "Microsoft";
        TwoFactorAuthPreferredApp["Other"] = "Other";
    })(TwoFactorAuthPreferredApp = appn.TwoFactorAuthPreferredApp || (appn.TwoFactorAuthPreferredApp = {}));
    let XeroApi;
    (function (XeroApi) {
        XeroApi["None"] = "";
        XeroApi["Accounting"] = "Accounting";
        XeroApi["PayrollAU"] = "PayrollAU";
        XeroApi["PayrollNZ"] = "PayrollNZ";
        XeroApi["PayrollUK"] = "PayrollUK";
    })(XeroApi = appn.XeroApi || (appn.XeroApi = {}));
    let XeroEndpoint;
    (function (XeroEndpoint) {
        XeroEndpoint["Accounts"] = "Accounts";
        XeroEndpoint["Contacts"] = "Contacts";
        XeroEndpoint["Employees"] = "Employees";
        XeroEndpoint["Invoices"] = "Invoices";
        XeroEndpoint["Items"] = "Items";
        XeroEndpoint["Timesheet"] = "Timesheet";
        XeroEndpoint["TrackingCategories"] = "TrackingCategories";
    })(XeroEndpoint = appn.XeroEndpoint || (appn.XeroEndpoint = {}));
    let QuickBooksOnlineEndpoint;
    (function (QuickBooksOnlineEndpoint) {
        QuickBooksOnlineEndpoint["None"] = "";
        QuickBooksOnlineEndpoint["Customer"] = "Customer";
        QuickBooksOnlineEndpoint["Invoice"] = "Invoice";
        QuickBooksOnlineEndpoint["TimeActivity"] = "TimeActivity";
        QuickBooksOnlineEndpoint["Class"] = "Class";
    })(QuickBooksOnlineEndpoint = appn.QuickBooksOnlineEndpoint || (appn.QuickBooksOnlineEndpoint = {}));
    let QuickBooksOnlineOperation;
    (function (QuickBooksOnlineOperation) {
        QuickBooksOnlineOperation["None"] = "";
        QuickBooksOnlineOperation["Create"] = "Create";
        QuickBooksOnlineOperation["FullUpdate"] = "FullUpdate";
        QuickBooksOnlineOperation["SparseUpdate"] = "SparseUpdate";
    })(QuickBooksOnlineOperation = appn.QuickBooksOnlineOperation || (appn.QuickBooksOnlineOperation = {}));
    let AcumaticaEndpoint;
    (function (AcumaticaEndpoint) {
        AcumaticaEndpoint["None"] = "None";
        AcumaticaEndpoint["GenericInquiry"] = "GenericInquiry";
        AcumaticaEndpoint["Customers"] = "Customers";
        AcumaticaEndpoint["Contacts"] = "Contacts";
        AcumaticaEndpoint["SalesOrders"] = "SalesOrders";
        AcumaticaEndpoint["Vendors"] = "Vendors";
        AcumaticaEndpoint["PurchaseOrders"] = "PurchaseOrders";
        AcumaticaEndpoint["Employees"] = "Employees";
        AcumaticaEndpoint["TimeEntries"] = "TimeEntries";
        AcumaticaEndpoint["ProjectTasks"] = "ProjectTasks";
    })(AcumaticaEndpoint = appn.AcumaticaEndpoint || (appn.AcumaticaEndpoint = {}));
    let AcumaticaOperation;
    (function (AcumaticaOperation) {
        AcumaticaOperation["None"] = "None";
        AcumaticaOperation["Create"] = "Create";
        AcumaticaOperation["Update"] = "Update";
    })(AcumaticaOperation = appn.AcumaticaOperation || (appn.AcumaticaOperation = {}));
    let AcumaticaAction;
    (function (AcumaticaAction) {
        AcumaticaAction["None"] = "None";
        AcumaticaAction["Activate"] = "Activate";
        AcumaticaAction["Complete"] = "Complete";
        AcumaticaAction["CancelTask"] = "CancelTask";
        AcumaticaAction["Hold"] = "Hold";
    })(AcumaticaAction = appn.AcumaticaAction || (appn.AcumaticaAction = {}));
})(appn || (appn = {}));
